import { Components, Theme } from "@mui/material";

export const MuiListItemText: Components<Theme>["MuiListItemText"] = {
  defaultProps: {
    slotProps: {
      primary: {
        variant: "body1",
      },
    },
  },
};
